module.exports = __webpack_public_path__ + "0904cd4cbf788f47f5f2d689b58d4ec4.mp3";